
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscription-terms-and-conditions",
      function () {
        return require("private-next-pages/subscription-terms-and-conditions/index.route.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscription-terms-and-conditions"])
      });
    }
  